import { selectGtoState, useDispatch, gerenciaTecnicaSlice } from "../../../../stateManagement/redux"
import ButtonBig, { ButtonWs } from "../../../../shared/components/button_big"
import { useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { uploadConsolidatedActivities } from '../../../../stateManagement/redux/slices/gerencia_tecnica/asyncReducers'
import { RoutesWeb } from "../../../../shared/interfaces/routes";
import { CustomInput } from "../../../../shared/components/customInput";
import { projectList } from "../../../../shared/util/projectList";
import { formatDateToYYYYMMDD } from "../../../../shared/util/formatDates";
import { getSummary, MessageSummary } from "src/tecnica/utils/getSummary";

export const UploadActivitiesModal = ({ close, sortActivitiesToUpload, executedDate }: { close: any, sortActivitiesToUpload: any[], executedDate: any }) => {


    const mainState = useSelector(selectGtoState);
    const navigate = useNavigate();

    const [icon, setIcon] = useState('/assets/gifs/uploading.gif')

    const dispatch = useDispatch();

    const [showClose, setShowClose] = useState(false)

    const [messageSummary, setMessageSummary] = useState<MessageSummary>()

    const [validateNE001, setvalidateNE001] = useState(false)

    const [uploadingStep, setuploadingStep] = useState("")

    const [wsMessage, setWsMessage] = useState("")

    const continueWithNE001 = () => {
        dispatch(gerenciaTecnicaSlice.actions.setUploadingStep("CheckWsMessage"))
        // dispatch(uploadConsolidatedActivities(sortActivities, executedDate))
    }

    const startUpload = () => {
        dispatch(uploadConsolidatedActivities(sortActivitiesToUpload, executedDate))
    }

    useEffect(() => {

        let stepMessage = ''

        switch (mainState.uploadingStep) {
            case 'Error Uploading':
                setIcon('/assets/icons/error.svg')
                setShowClose(true)
                stepMessage = 'Error Uploading'
                break;

            case 'Task Uploaded':
                setIcon('/assets/icons/ok.svg')
                setShowClose(true)
                stepMessage = 'Task Uploaded'
                break;

            case 'Validate NE001':
                setIcon('/assets/icons/warnings.svg')
                setShowClose(true)
                setvalidateNE001(true)
                stepMessage = 'Por lo menos un usuario no se encuentra registrado y sera registrado como invitado, por lo cual no le contara la actividad en el desempeño, desea continuar ?'
                break;

            default:
                setIcon('/assets/gifs/uploading.gif')
                setShowClose(true)
                stepMessage = 'Uploading'
                break;
        }

        setuploadingStep(stepMessage)

        if (sortActivitiesToUpload.length === 0) {
            return
        }

        console.log({sortActivitiesToUpload})
        getSummary(sortActivitiesToUpload, setMessageSummary, executedDate, setWsMessage)

    }, [mainState.uploadingStep, sortActivitiesToUpload])

    const sendWsMessage = () => {
        const phoneNumber = '584246870497'; // Reemplaza con el número de teléfono deseado
        if (wsMessage !== "") {
            const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(wsMessage)}`;
            window.open(url, '_blank');
        }
    }


    if (mainState.uploadingStep === 'CheckWsMessage') {
        return (
            <div className='uploading_loader_container' >
                <div className='uploading_loader_container_input_container' style={{ width:'70vw', maxWidth:'700px' }} >
                    <div>Favor validar el resumen de la cuadrilla <span className="consolidate_files_container_table_row_warning">{messageSummary?.integrantes}</span> antes de subirlas</div>
                    <div className="ws_message_container">
                        <CustomInput label={"Cuadrilla"} value={messageSummary?.cuadrilla || ""} onChange={() => { }} disabled={true} />
                        <CustomInput label={"Pozos visitados"} value={messageSummary?.pozos_visitados || ""} onChange={() => { }} disabled={true} />
                        <CustomInput label={"Pozos aportando"} value={messageSummary?.pozos_aportando || ""} onChange={() => { }} disabled={true} />
                        <CustomInput label={"Pozos sin aporte"} value={messageSummary?.pozos_sin_aporte || ""} onChange={() => { }} disabled={true} />
                        <CustomInput label={"Pozos operando"} value={messageSummary?.pozos_operando || ""} onChange={() => { }} disabled={true} />
                        <CustomInput label={"Pozos IT"} value={messageSummary?.pozos_IT || ""} onChange={() => { }} disabled={true} />
                        <CustomInput label={"Pozos sin acceso"} value={messageSummary?.pozos_sin_acceso || ""} onChange={() => { }} disabled={true} />
                        <CustomInput label={"Pozos recolocado"} value={messageSummary?.pozos_recolocado || ""} onChange={() => { }} disabled={true} />
                        <CustomInput label={"Pozos en observacion"} value={messageSummary?.pozos_en_observacion || ""} onChange={() => { }} disabled={true} />
                        {/* <CustomInput label={"Pozos reespaceados"} value={messageSummary?.pozos_reespaceados || ""} onChange={() => { }} disabled={true} /> */}
                        <CustomInput label={"Pozo sin produccion"} value={messageSummary?.pozos_sin_produccion || ""} onChange={() => { }} disabled={true} />
                        <CustomInput label={"Pozos restaurados"} value={messageSummary?.pozos_restaurados || ""} onChange={() => { }} disabled={true} />
                        <CustomInput label={"Producción asociada"} value={messageSummary?.produccion_monitoreado || ""} onChange={() => { }} disabled={true} />
                        <CustomInput label={"Producción diferida"} value={messageSummary?.produccion_diferida || ""} onChange={() => { }} disabled={true} />
                        <CustomInput label={"Producción restaurada"} value={messageSummary?.produccion_restaurada || ""} onChange={() => { }} disabled={true} />
                        {/* <CustomInput label={"Cartas realizadas"} value={messageSummary?.cartas_realizadas || ""} onChange={() => { }} disabled={true} /> */}
                        <CustomInput label={"Estudios Echometer"} value={messageSummary?.estudios_echometer || ""} onChange={() => { }} disabled={true} />                                             
                        <CustomInput label={"Muestras"} value={messageSummary?.muestras || ""} onChange={() => { }} disabled={true} />                                             
                    </div>
                    {
                        <div className='Upload_files_container_upload_modal_container_button_container' >
                            {<ButtonBig text='Cerrar' onClick={close} />}
                            {(uploadingStep !== 'Task Uploaded') && <ButtonBig text='Continuar' onClick={startUpload} />}
                            {<ButtonWs text='Mensaje de WS' onClick={sendWsMessage} iconHeight={20} iconWidth={20} />}
                        </div>
                    }

                </div>
            </div>
        )

    }


    return (
        <div className='uploading_loader_container' >
            <div className='uploading_loader_container_input_container' >
                <img src={icon} width={130} height={130} alt='' />
                <div className="message_zone">{uploadingStep} </div>
                {
                    showClose &&
                    <div className='Upload_files_container_upload_modal_container_button_container' >
                        {<ButtonBig text='Cerrar' onClick={close} />}
                        {(uploadingStep !== 'Task Uploaded' && validateNE001) && <ButtonBig text='Continuar' onClick={continueWithNE001} />}
                        {uploadingStep === 'Task Uploaded' && <ButtonBig text='ir al historial' onClick={() => navigate(RoutesWeb.gerencia_tecnica_operaciones.history)} />}
                    </div>
                }
            </div>
        </div>
    )
}